import Service from '@ember/service';
import DefaultModelData from '../data/defaultmodeldata';
import { service } from '@ember/service';
import { computed } from '@ember/object';
import Utils from '../utils/utils';

import cloneDeep from 'lodash.clonedeep';
import merge from 'lodash.merge';

export default class InitialDataService extends Service {
    @service hashSelectedDataService;

    data = DefaultModelData;

    /**
     * This initial model data includes the defaults and
     * the selection model data.
     */
    @computed('metadata') get modelData() {
        let modelData = this.metadataToModelData(this.metadata);

        /**
         * Merge the selection model data and the other default model settings into
         * the default hash model data
         *
         * Note that this data will only be in the model data not the metadata
         * */
        return merge(modelData, this.data.otherModelSettings);
    }

    @computed('data', 'hashSelectedDataService.modelData') get defaultModelData() {
        let defaultModelData = cloneDeep(this.data.hashModelSettings),
            selectionModelData = this.hashSelectedDataService.modelData;

        defaultModelData.samplingRate = selectionModelData.selectedAdc.samplingRate;
        defaultModelData.vref = selectionModelData.selectedAdc.vref;
        defaultModelData.rext = Math.max(
            selectionModelData.selectedAdc.rext,
            selectionModelData.selectedDriver.rfiltMin,
        );
        defaultModelData.cext = selectionModelData.selectedAdc.cext;

        if (
            'defaultFrequency' in selectionModelData.selectedAdc &&
            !Utils.isNullOrWhiteSpace(selectionModelData.selectedAdc.defaultFrequency)
        )
            defaultModelData.frequency = selectionModelData.selectedAdc.defaultFrequency;

        return defaultModelData;
    }

    /**
     * Provides metadata that helps in determining how to get data
     * from the hash and set it to the model.
     */
    @computed('defaultModelData') get metadata() {
        let initialModelData = cloneDeep(this.defaultModelData);

        let metadata = {};
        Object.keys(initialModelData).forEach((key) => this._getMetadata(key, initialModelData[key], metadata));

        return metadata;
    }

    metadataToModelData(metadata) {
        let modelData = {};

        Object.keys(metadata).forEach((key) => {
            let item = metadata[key];
            modelData[item.appVarName] = item.hashKey ? item.default : item;
        });

        return modelData;
    }

    getMetadataKey(modelName) {
        return modelName in this.data.modelToHashMap ? this.data.modelToHashMap[modelName] || modelName : modelName;
    }

    getHashMetadata(keys) {
        let metadata = {};

        // Get the additional metadata
        keys.forEach((key) => this._getMetadata(key, this.defaultModelData[key], metadata));
        return metadata;
    }

    getHashMetadataItem(key) {
        return this.getHashMetadata([key])[this.getMetadataKey(key)];
    }

    _getMetadata(modelKey, value, metadata) {
        let hashKey = this.data.modelToHashMap[modelKey],
            addlDefaults = this.data.additionalHashModelSettings;

        metadata[hashKey || modelKey] = {
            default: value,
            appVarName: modelKey,
            hashKey: hashKey || modelKey,
            isNumeric: Utils.isNumeric(value),
            isBoolean: Utils.isBoolean(value),
            addlDefaults: addlDefaults[modelKey],
        };
    }
}
